<template>
  <div class="row">
    <div class="col-12">
      <h2>{{ $t('payment_provider_accounts.create') }}</h2>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="createPaymentProviderAccount">
        <FormFields v-model:formData="formData"/>
        <div class="col-12 col-lg-3 mt-3">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {usePaymentProviderAccountStore} from "@/stores/payment_provider_account";
import {Helpers} from "@/helpers";
import {ROUTES} from "@/scripts/constants";
import FormFields from "@/pages/payment_provider_accounts/components/FormFields.vue";

export default {
  name: 'PaymentProviderAccountsCreate',
  components: {
    FormFields,
  },
  setup() {
    return {
      paymentProviderAccountStore: usePaymentProviderAccountStore(),
    }
  },
  data() {
    return {
      formData: {
        organization_id: '',
        provider_key: '',
        name: '',
        status: '',
        api_key: '',
        profile_id: '',
        default_currency: 'EUR',
        webhook_url: '',
      },
      saving: false,
    }
  },
  created() {
    this.setTitle(this.$t('payment_provider_accounts.create'))
  },
  methods: {
    buildPayload() {
      return {
        organization_id: this.formData.organization_id === '' ? null : Number(this.formData.organization_id),
        provider_key: this.formData.provider_key,
        name: this.formData.name,
        status: this.formData.status,
        api_key: this.formData.api_key,
        profile_id: this.formData.profile_id,
        default_currency: this.formData.default_currency,
        webhook_url: this.formData.webhook_url,
      }
    },
    createPaymentProviderAccount() {
      const payload = this.buildPayload()
      this.saving = true
      this.paymentProviderAccountStore.create(payload).then(({data}) => {
        Helpers.emitter.emit('success', this.$t('payment_provider_accounts.created'))
        const id = data?.payment_provider_account?.id
        if (id) {
          this.$router.push({name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.SHOW, params: {id}})
          return
        }
        this.$router.push({name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.INDEX})
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>
